<mat-icon (click)="handlePOPUP(data,header)">visibility</mat-icon>